import { Link, Typography } from "@povio/ui";

import { UrlUtils } from "@/util/url.utils";

interface IProps {
  value?: string | null;
  segment: string;
  isLink?: boolean;
}

const ProfileWorkExperienceItem = ({ value, segment, isLink }: IProps) => {
  if (!value) return null;

  if (isLink) {
    return (
      <div>
        <Link
          className="block truncate"
          href={UrlUtils.startLinkWithHttps(value)}
          target="_blank"
        >
          {value}
        </Link>
        <Typography
          variant="default"
          size="label-4"
          className="text-text-default-3 capitalize"
        >
          {segment}
        </Typography>
      </div>
    );
  }

  const textParts = UrlUtils.parseTextWithLinks(value);

  return (
    <div>
      <Typography
        variant="default"
        size="label-4"
        className="wrap-break-words"
        data-testid="profile-work-experience-item-value"
      >
        {textParts.map((part, index) => {
          if (part.type === "link") {
            return (
              <Link
                key={index}
                href={part.url || "#"}
                target="_blank"
                className="text-primary hover:underline"
              >
                {part.content}
              </Link>
            );
          }
          return part.content;
        })}
      </Typography>
      <Typography
        variant="default"
        size="label-4"
        className="text-text-default-3 capitalize"
        data-testid="profile-work-experience-item-segment"
      >
        {segment}
      </Typography>
    </div>
  );
};

export default ProfileWorkExperienceItem;
